module.exports = __webpack_public_path__ + "static/11-4af2d30036f2dc6d5a0d87daad8a5086.jpg";